import Cookies from "js-cookie";

export function getCookie(item) {
  const sesionCookie = Cookies.get(item);
  if (sesionCookie) {
    try {
      return JSON.parse(sesionCookie);
    } catch (error) {
      Cookies.remove(item);
      return null;
    }
  } else {
    return null; 
  }
}
